
const REFRESH = "REFRESH";
const ACCESS = "ACCESS";
const SUCCESS_SYNC = "SUCCESS";
const ERROR_SYNC = "ERROR"

const enumTokenTypes = {
    [REFRESH]: "Refresh token",
    [ACCESS]: "Access token"
};

const TYPE_OTHERS = "others";
const TYPE_PRODUCTS = "products";
const TYPE_VENDOR = "vendor";
const TYPE_SHIPPING_ADDRESS = "shipping_address";
const TYPE_REQUEST_BODY = "validation_request_body";
const TYPE_TOKEN = "token";

exports.ACCESS = ACCESS;
exports.REFRESH = REFRESH;
exports.enumTokenTypes = enumTokenTypes;
exports.SUCCESS_SYNC = SUCCESS_SYNC;
exports.ERROR_SYNC = ERROR_SYNC;
exports.TYPE_REQUEST_BODY = TYPE_REQUEST_BODY;
exports.TYPE_OTHERS = TYPE_OTHERS;
exports.TYPE_PRODUCTS = TYPE_PRODUCTS;
exports.TYPE_VENDOR = TYPE_VENDOR;
exports.TYPE_SHIPPING_ADDRESS = TYPE_SHIPPING_ADDRESS;
exports.TYPE_TOKEN = TYPE_TOKEN;